import React, { useEffect } from 'react';
import { Form, Col, Row, Card, Switch } from 'antd';
import Title from 'antd/lib/typography/Title';
import {
  EditOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import ModalSFS from '../../../../../../../components/theme_components/ModalSFS';
import { useForm } from 'antd/lib/form/Form';
// import IntramarqueModal from './IntramarqueModal';
import IPen from 'icons/IPen';
import TaskSButtonSFS from 'pages/workflow/workflowSFS/TasksButtonSFS';
import ButtonLink from 'components/theme_components/ButtonLink';
import TasksSwitchButtonSFS from 'pages/workflow/workflowSFS/TasksSwitchButtonSFS';
import { toCurrency } from 'utils/utils';

export type IntramarqueCardProps = {
  silo: any;
  tpid: number;
  refetch: () => void;
  index?: number;
  hideDeletebtn: boolean;
  action?: string;
  tptype?: string;
};

const IntramarqueCard = ({
  silo,
  refetch,
  tpid,
  tptype
}: IntramarqueCardProps) => {
  const [form] = useForm();

  return (
    <Card
      className="activity-card mb-2"
    >
      <Row gutter={5} justify="start">
        <Col span={3} className='align-self-center'>
          <Title level={4} className="font-weight-500 font-size-18 mb-0">
            {silo?.silobrand}
          </Title>
        </Col>
        <Col span={10} className='align-self-center'>
          <Title level={4} className="font-size-15 font-weight-500 mb-0">
            {silo?.exclusionsAuthList?.map((sil: any, index: number) => {
              return <p style={{ float: 'left', marginRight: '10px' }}>
                <span>{sil.tpname + ' '}</span> <span>{'(' + sil.tpmainadrcity + ' ) '}</span> {index != silo?.exclusionsAuthList?.length - 1 && ' - '}
              </p>
            })}
          </Title>
        </Col>
        <Col span={3}>
          {toCurrency(silo?.siloavailbleamount)}
        </Col>


        <Col span={3}>
          {toCurrency(silo?.siloavailbleamountmpea)}
        </Col>

        <Col span={2} />

        <Col span={3}>
          <TasksSwitchButtonSFS
            clientName=""
            entityId={tpid}
            entityReference=""
            entityName="THIRDPARTY"
            currcode=""
            funcode="evactivatesilointra"
            wizardsteps
            // refetch={() => refetch()}
            width={1000}
            title="evactivatesilointra"
            refetch={() => {
              refetch();
            }}
            dataList={silo?.tpAuthorizationResponses}
            prcode={silo.siloprcode}
            defaultChecked={silo.silostatus === 'ACTIVE' ? true : false}
            dataInput={silo}
            tptype={tptype}
          />



          <TaskSButtonSFS
            clientName=""
            entityId={tpid}
            entityReference=""
            entityName="THIRDPARTY"
            currcode=""
            funcode="evupdatesilointra"
            wizardsteps
            width={1000}
            title="evupdatesilointra"
            refetch={() => {
              refetch();
            }}
            dataList={silo?.tpAuthorizationResponses}
            prcode={silo.siloprcode}
            dataInput={silo}
            tptype={tptype}
          >
            <IPen
              className=" font-size-25 floatRight"
              style={{ cursor: "pointer" }}
            />
          </TaskSButtonSFS>
          {/* <ModalSFS
            width={920}
            trigger={({ setVisible }) => (
              <IPen
                className=" font-size-25 floatRight mr-10"
                onClick={() => { setVisible(true); }}
              />
            )}
            prevLabel={"  " + silo.silobrand + " " + silo.siloprcode}
            title="updateIntraMarque"
            className='display-none'
            hideCloseButton
          >
            <IntramarqueModal tpAuthorizationResponses={silo?.tpAuthorizationResponses} setVisible={function (visible: boolean): void {
              throw new Error('Function not implemented.');
            }} />
          </ModalSFS> */}

        </Col>
      </Row>
    </Card>
  );
};

export default IntramarqueCard;
